import { render, staticRenderFns } from "./RegenerateTimes.vue?vue&type=template&id=20afa360&scoped=true&"
import script from "./RegenerateTimes.vue?vue&type=script&lang=js&"
export * from "./RegenerateTimes.vue?vue&type=script&lang=js&"
import style0 from "./RegenerateTimes.vue?vue&type=style&index=0&id=20afa360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20afa360",
  null
  
)

export default component.exports